// extracted by mini-css-extract-plugin
export default {"mess":"PurposeTags_mess__Qioo0","tags":"PurposeTags_tags__9Bjd5","message_tag":"PurposeTags_message_tag__8Jlo0"};